/**
 * Resolve the default project/environment keys from API response data.
 *
 * Prefers the user's saved defaults; falls back to the first project/environment
 * in the list. Safe to call when projects or environments are empty or absent.
 *
 * @param {object} data - Raw API response data
 * @returns {{ projectKey: string|null, environmentKey: string|null }}
 */
export function resolveCurrentSelection(data) {
    const firstProject = data.projects?.data?.[0] ?? null
    const firstProjectKey = firstProject?.key ?? null
    const firstEnvironmentKey =
        firstProject?.environments?.data?.[0]?.key ?? null

    return {
        projectKey:
            data.user.data.default_project_key != null
                ? data.user.data.default_project_key
                : firstProjectKey,
        environmentKey:
            data.user.data.default_environment_key != null
                ? data.user.data.default_environment_key
                : firstEnvironmentKey,
    }
}
